export function reorderRfiRows<T extends { id: string; section: string }>(
  rows: T[],
  sourceId: string,
  targetId: string,
  placement: "before" | "after",
): T[] {
  const source = rows.find(row => row.id === sourceId);
  const target = rows.find(row => row.id === targetId);
  if (!source || !target || source === target || source.section !== target.section) return rows;

  const reordered = rows.filter(row => row.id !== sourceId);
  const targetIndex = reordered.findIndex(row => row.id === targetId);
  reordered.splice(targetIndex + (placement === "after" ? 1 : 0), 0, source);
  return reordered.every((row, index) => row === rows[index]) ? rows : reordered;
}
